import { BaseHover } from './base';
import { HoverType } from '../types';
import { css } from '../../emotion';
export class Opacity extends BaseHover {
    constructor(option) {
        super(HoverType.Opacity);
        this.opacity = (option === null || option === void 0 ? void 0 : option.opacity) || 50;
    }
    animateProps() {
        return {
            from: this.generateProps({ opacity: 1 }),
            to: this.generateProps({ opacity: this.opacity / 100 }),
            loop: {
                opacity: 1,
                reverse: true
            }
        };
    }
    cssProps() {
        return css `
      transition-duration: 0.3s;
      transition-property: opacity;
      opacity: 1;

      &:hover, &:focus, &:active {
        opacity: ${this.opacity / 100};
      }
    `;
    }
}
